<template>
    <div class="app-container"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="10">
        <div class="app-content">
            <gt-cell v-for="item in shops"
                     :key="item.id"
                     :cell="item"
                     :title="item.name"
                     @cellClick="handleCellClick">
                <div slot='left'
                     class="left-img">
                    <img :src="item.logo"
                         alt="">
                </div>
                <div slot='wrapper'>
                    <p class="msg">
                      <span class="first">
                        <span class="price" v-if="((item.shopConsume/ 100.0).toFixed(0)) > 0">￥{{item.shopConsume | formatMoney2Yuan}}/人</span>
                        <span class="mall">{{item.mallName}}</span>
                        <span class="distance">
                            {{item.meter | formateMeter}}
                        </span>
                      </span>
                      <span class="tags">
                          <gt-tag v-for="(service, index) in item.service" :key="index">{{service}}</gt-tag>
                      </span>
                      <span class="details">
                          <span v-for="(good, index) in item.goods" :key="good.goodsCode" class="good">{{good.name}}<span v-if="index < (item.goods.length - 1)">，</span></span>
                      </span>
                    </p>
                </div>
                <!-- <div slot='bottom'>
                    <p class="bottom-msg"
                       v-for="good in item.goods"
                       :key="good.goodsCode">
                        <gt-tag color="white"
                                bg-color="#F45C42"
                                :no-radius="noRadius">团</gt-tag><span class="msg-text">{{good.price | formatMoney2Yuan}}元</span><span class="msg-text">{{good.name}}</span>
                    </p>
                </div> -->
            </gt-cell>
        </div>
        <div>
            <p v-show="loading"
               class="page-infinite-loading">
                {{loadingText}}
            </p>
            <p v-show="finished"
               class="page-infinite-loading">
                {{finishedText}}
            </p>
        </div>
    </div>
</template>
<script>
import gtCell from "./components/gtCell.vue";
import gtTag from "./components/gtTag.vue";
import { InfiniteScroll } from "mint-ui";
import { fetchSelectShops } from "../../common/api/delicacy";
import JSBridge from "../../jsbridge";
import { Toast } from "mint-ui";
export default {
  name: "cateringBusiness",
  directives: { InfiniteScroll },
  components: {
    gtCell,
    gtTag
  },
  data() {
    return {
      categoryNo: this.$route.query.categoryNo,
      noRadius: true,
      loading: true,
      rateMax: 100,
      loadingText: "正在加载更多...",
      finished: false,
      finishedText: "暂无更多内容",
      shops: [],
      total: 0,
      pageSize: 20,
      pageNo: 0,
      location: {
        latitude: 0, // 维度
        longitude: 0 // 经度
      }
    };
  },
  created() {
    this.getLocation();
    // this.fetchSelectShops()
  },
  filters: {
    formatMoney2Yuan(value) {
      return (value / 100.0).toFixed(0);
    },
    formateMeter(value) {
      value = Number(value);
      if (parseInt(value / 1000) > 0) {
        let v = parseInt(value / 100) + 1;
        let z = v / 10;
        let s = v % 10;
        return `${parseInt(z)}.${parseInt(s)}km`;
      }
      if (parseInt(value / 100) > 0) {
        let v = parseInt(value / 10) + 1;
        let z = v / 10;
        let s = v % 10;
        return `${parseInt(z)}${parseInt(s)}0m`;
      }
      if (parseInt(value / 10) > 0) {
        let v = parseInt(value / 10) + 1;
        let z = v / 10;
        return `${parseInt(z)}0m`;
      }
      return `10m`;
    }
  },
  methods: {
    isCorrectLocation(location) {
      if (location.latitude === 0 && location.longitude === 0) return false;
      return true;
    },
    handleCellClick(cell) {
      let nativeParams = {
        shopId: cell.id + "",
        mallId: cell.mallId + ""
      };
      let params = {
        cmd: "C0070002",
        params: JSON.stringify(nativeParams)
      };
      JSBridge.Common.Caller_Common_Base_cmd(params, () => {});
    },
    getLocation() {
      JSBridge.Common.Caller_Common_Base_location(location => {
      let locationParse =
        typeof location === "string" ? JSON.parse(location) : location;
      if (!this.isCorrectLocation(locationParse)) {
        this.finished = true;
        this.loading = false;
        Toast("定位失败！");
        return;
      }
      this.location = locationParse;
      this.fetchSelectShops();
      })
    },
    initAllRate() {
      let list = this.shops;
      for (let i = 0; i < list.length; i++) {
        list[i].rate = this.formateRate(list[i].shopPoint);
      }
    },
    formateRate(value) {
      return value / 20.0;
    },
    fetchSelectShops() {
      if (!this.isCorrectLocation(this.location)) return;
      this.loading = true;
      this.finished = false;
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo + 1,
        categoryNo: this.categoryNo + "",
        lat: this.location.latitude,
        lng: this.location.longitude
      };
      fetchSelectShops(params)
        .then(res => {
          if (res.data.code === 0) {
            if (res.data.data.shops.length === 0) {
              this.loading = false;
              this.finished = true;
              return;
            }
            this.pageNo++;
            let data = res.data.data;
            let page = res.data.data.page;
            this.total = page.total || 0;
            this.pageSize = page.pageSize;
            this.shops = this.shops.concat(data.shops);
            this.initAllRate();
          } else {
            Toast(res.msg);
          }
        })
        .catch(err => {
          Toast(err);
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
            if (this.shops.length >= this.total) {
              this.finished = true;
            }
          });
        });
    },
    loadMore() {
      if (this.loading || this.finished) return;
      this.$nextTick(() => {
        this.fetchSelectShops();
      });
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/css/px2rem.scss";
@import "../../assets/css/colors.scss";
.rate {
  height: px2rem(14) !important;
  .el-rate__item {
    font-size: px2rem(14) !important;
    .el-rate__icon {
      font-size: px2rem(14) !important;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/css/px2rem.scss";
@import "../../assets/css/colors.scss";
$font-gray: #666666;
.app-container {
  background-color: $bgColor;
  .app-content {
    background-color: white;
  }
}
.page-infinite-loading {
  text-align: center;
  padding: px2rem(30) 0;
  line-height: px2rem(20);
  font-size: px2rem(12);
  color: $gray;
}
.gt-cell {
  .left-img {
    width: px2rem(128) !important;
    height: px2rem(88) !important;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .wrapper {
    .rate-box {
    }
    .msg {
      font-size: px2rem(12) !important;
      .first {
        display: block;
        display: flex;
        flex-direction: row;
        .price {
          display: inline-block;
          margin-right: px2rem(10);
        }
        .mall {
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          outline: 0;
          flex: 1;
        }
        .distance {
          width: auto;
          margin-left: px2rem(10);
        }
      }
      .tags {
        display: block;
        margin-top: px2rem(3);
      }
      .details {
        position: absolute;
        width: 95%;
        bottom: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        outline: 0;
      }
    }
  }
  .bottom {
    .bottom-msg {
      padding: 0;
      font-size: px2rem(14);
      margin-top: px2rem(8);
      margin-bottom: px2rem(8);
      margin-left: px2rem(82);
      .tag {
        margin: 0 !important;
      }
      .msg-text {
        margin-left: px2rem(8);
        line-height: px2rem(20);
        color: $font-gray;
      }
    }
  }
}
</style>
